export const chartOptions = (theme) => {
    return {
        labels: ['Australia', 'New Caledonia', 'New Zealand', 'Tahiti', 'Refinements'],
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                const totalSerie = opts.w.globals.series[opts.seriesIndex];
                const percent = val.toFixed(0) + '%';
                return `${totalSerie} (${percent})`;
            },
        },
        colors: [
            theme.palette.info.main,
            theme.palette.success.light,
            theme.palette.warning.main,
            theme.palette.tertiary.main,
            theme.palette.quaternary.main,
        ],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
    };
};
